import { request, RequestHookParams, ResponseWithMeta, useRequest } from 'src/shared/api';
import { apiPublicRoutesMap, apiRoutesMap } from 'src/shared/config';
import { Product } from 'src/types/api';
import { ProductCard } from './model';

export const requestCodesByBarcodes = (barcodes: Array<string | number>) =>
  request.post<ResponseWithMeta<{ [key: number]: Product }>>(
    apiPublicRoutesMap.searchProductsByBarcodes.getRoute(),
    {
      barcodes,
    },
  );

export interface ProductCardResponse {
  data: ProductCard | null;
  errors?: string[];
}

export const useProduct = (params: RequestHookParams<{ code: number | string }>) =>
  useRequest<ProductCardResponse>(
    apiRoutesMap.product.getRoute(params.variables.code),
    params,
  );
